import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { StyledTableRow, TypographyNormal } from "../../customComponent";
import {
  Box,
  Checkbox,
  Chip,
  CircularProgress,
  IconButton,
  TableCell,
  Tooltip,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { dateFormat } from "../../../helpers/dateFormat";
import { colorStyling } from "../../../helpers/color";

const ContentTemplateItem = ({
  content,
  permission,
  selectItem,
  unselectItem,
  selectedFlag,
  openMore,
  handleClickMore,
  loadingItem,
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation("cms");

  const contentPermission = permission?.content;
  const assetPermission = permission?.asset;

  const handleCheckbox = () => {
    const updated = !selectedFlag;
    if (updated === true) {
      selectItem(content);
    } else {
      unselectItem(content.id);
    }
  };

  const parseTooltipTitle = (which) => {
    switch (which) {
      case "delete":
        if (contentPermission?.delete) {
          return content.canDelete
            ? t("item.deleteTip")
            : t("item.cantDeleteTip");
        }
        break;

      case "update":
        if (contentPermission?.update && assetPermission?.read) {
          return content.canUpdate ? t("item.editTip") : t("item.cantEditTip");
        }
        break;

      default:
        break;
    }

    return t("item.notAuthorized");
  };

  const disableDeleteCondition = () => {
    return !content.canDelete || !contentPermission?.delete;
  };

  const disableUpdateCondition = () => {
    return !content.canUpdate || !contentPermission?.update;
  };

  return (
    <>
      <StyledTableRow>
        <TableCell align="left">
          <Box display={"flex"} alignItems={"center"}>
            <Box display={"flex"} alignItems={"center"} sx={{ mr: 2 }}>
              <Checkbox
                checked={selectedFlag}
                size="small"
                disabled={disableDeleteCondition() || disableUpdateCondition()}
                onClick={handleCheckbox}
                sx={{ padding: "4px" }}
              />
            </Box>
            <Box
              display={"flex"}
              flexDirection={"column"}
              alignItems={"center"}
              width={"fit-content"}
            >
              <Box width={"100%"} display={"flex"}>
                <TypographyNormal>{content.name}</TypographyNormal>
              </Box>

              {content.tags?.length > 0 && (
                <Box
                  width={"100%"}
                  display={"flex"}
                  gap={1}
                  sx={{ mt: "2px", ml: 2, flexWrap: "wrap" }}
                >
                  {content.tags.map((item, index) => (
                    <Chip
                      key={index}
                      label={item}
                      size="small"
                      sx={{ color: "white", backgroundColor: "mediumseagreen" }}
                    />
                  ))}
                </Box>
              )}
            </Box>
          </Box>
        </TableCell>
        <TableCell align="center">{dateFormat(content.updatedAt)}</TableCell>
        <TableCell align="center">{content.updatedBy?.name ?? "—"}</TableCell>

        <TableCell align="right">
          <Box display="flex" justifyContent={"end"}>
            <Tooltip
              arrow
              disableInteractive
              title={parseTooltipTitle("update")}
            >
              <Box sx={{ width: "fit-content" }}>
                <IconButton
                  variant="contained"
                  disabled={
                    loadingItem ||
                    disableUpdateCondition() ||
                    !assetPermission?.read
                  }
                  onClick={() =>
                    navigate(`/cms/content-template/edit/${content.id}`)
                  }
                  sx={{
                    color: colorStyling.lightgreen,
                  }}
                >
                  <EditIcon />
                </IconButton>
              </Box>
            </Tooltip>

            <Box sx={{ width: "fit-content" }}>
              <IconButton
                aria-controls={openMore ? "basic-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={openMore ? "true" : undefined}
                onClick={handleClickMore}
                sx={{ color: colorStyling.black }}
              >
                <MoreVertIcon />
              </IconButton>
            </Box>
          </Box>
        </TableCell>

        <TableCell sx={{ width: 0, padding: 0, position: "relative" }}>
          <Box
            display={loadingItem ? "flex" : "none"}
            justifyContent={"right"}
            alignItems={"center"}
            width={"5555px"}
            height={"100%"}
            sx={{
              pr: "120px",
              top: 0,
              right: 0,
              opacity: 0.4,
              position: "absolute",
              backgroundColor: "lightgrey",
            }}
          >
            <CircularProgress
              size={22}
              thickness={3}
              sx={{ color: colorStyling.primary }}
            />
          </Box>
        </TableCell>
      </StyledTableRow>
    </>
  );
};

export default ContentTemplateItem;
